module.exports = __webpack_public_path__ + "static/media/goldenprize-tuna-flakes-oil-lid.6a52f595.png";